import { SectionTitle } from "@/components/SectionHeader";
import { Eyebrow } from "@/components/Eyebrow";
import { ButtonLink } from "@/components/ui/Button";

// Without a URL the rows and button render inert rather than as dead links.
const CAREERS_URL: string | undefined = undefined;

const JOBS = [
  {
    title: "Senior Hardware Engineer",
    meta: "Engineering · Remote · Full-time",
  },
  { title: "Product Designer", meta: "Product & Design · Remote · Full-time" },
  {
    title: "Senior Software Engineer, Platform",
    meta: "Engineering · San Francisco, CA · Full-time",
  },
  {
    title: "Technical Program Manager",
    meta: "Product · San Francisco, CA · Full-time",
  },
  {
    title: "Director of Hospitality Partnerships",
    meta: "Business Development · San Francisco, CA · Full-time",
  },
];

export function CareersSection() {
  return (
    <section id="careers" className="px-8 py-20 md:px-6 md:py-16 lg:pb-32">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 md:grid md:grid-cols-2 md:gap-10 lg:gap-16">
        <div className="contents md:flex md:max-w-md md:flex-col md:items-start md:gap-16">
          <div className="flex flex-col gap-6">
            <Eyebrow>Work at Somo</Eyebrow>
            <SectionTitle>
              Help us build what hospitality needs next
            </SectionTitle>
          </div>
          <ButtonLink
            href={CAREERS_URL}
            variant="outline-brand"
            size="lg"
            className="order-last self-start md:order-none"
          >
            See All Listings
          </ButtonLink>
        </div>
        <ul className="flex w-full flex-col">
          {JOBS.map((job, index) => (
            <li key={job.title}>
              {index > 0 && (
                <hr
                  aria-hidden
                  className="my-6 h-px border-0 bg-line md:my-4 md:bg-transparent md:bg-gradient-to-r md:from-line md:to-primary"
                />
              )}
              <a
                href={CAREERS_URL}
                className="group flex items-center justify-between gap-6 py-2"
              >
                <span className="flex flex-col gap-2">
                  <span className="text-lg leading-title text-primary transition-colors md:text-2xl md:leading-tight group-hover:text-brand">
                    {job.title}
                  </span>
                  <span className="text-sm leading-normal tracking-body text-secondary md:text-base">
                    {job.meta}
                  </span>
                </span>
                <svg
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden
                  className="size-4 shrink-0 text-primary transition-transform group-hover:translate-x-1"
                >
                  <path d="m6 3 5 5-5 5" />
                </svg>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
